import React from 'react';

var _path;

var SvgGamesConsoleMajor = function SvgGamesConsoleMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 2.774c0-.432.344-.774.77-.774H14V0h-2.23A2.769 2.769 0 0 0 9 2.774V5H5.55A5 5 0 0 0 .573 9.516l-.557 5.737a3.416 3.416 0 0 0 6.712 1.17l.073-.291A1.5 1.5 0 0 1 8.255 15h3.74a1.5 1.5 0 0 1 1.454 1.132l.098.386a3.288 3.288 0 0 0 6.46-1.124l-.569-5.876A5 5 0 0 0 14.461 5H11V2.774zM6 7a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H7v1a1 1 0 1 1-2 0v-1H4a1 1 0 1 1 0-2h1V8a1 1 0 0 1 1-1zm7.5 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm3 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  })));
};

export { SvgGamesConsoleMajor as S };
